class Accordeon {
    constructor(el) {
        this.container = el;
        this.titles = this.container.querySelectorAll('.js-acc-title');

        this.bindClick();
    }

    bindClick() {
        this.titles.forEach(title => {
            const $text = $(title.nextElementSibling);

            title.addEventListener('click', () => {
                if (title.classList.contains('_is-open')) {
                    title.classList.remove('_is-open');
                    $text.clearQueue().slideUp(200);
                } else {
                    title.classList.add('_is-open');
                    $text.clearQueue().slideDown(200);
                }
            });
        });
    }
}

document.querySelectorAll('.js-accordeon').forEach(el => {
    new Accordeon(el);
});



// WEBPACK FOOTER //
// ./_src/js/Accordeon.js